import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoContent from '../../../components/common/InfoContent';

const VAT = ({ 
  userData, 
  setUserData, 
  store, 
  formErrors, 
  setFormErrors, 
  infoField, 
  showInfo,
  hideInfo 
}) => {
  const { t } = useTranslation();
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({ ...prev, [name]: value }));
    
    if (setFormErrors && !store.vat_optional && value.trim() === '') {
      setFormErrors(prev => ({
        ...prev,
        vat: t("Le numéro de TVA est obligatoire")
      }));
    } else if (setFormErrors) {
      setFormErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.vat;
        return newErrors;
      });
    }
  };

  const isRequired = !store.vat_optional;

  return (
    <div className="formField">
      <div className={`formControl ${store.vatInfo ? 'hasInfo' : ''}`}>
        <input
          type="text"
          name="vat"
          id="vat"
          value={userData.vat || ''}
          onChange={handleInputChange}
          placeholder={`${t('Numéro de TVA')} ${isRequired ? '*' : ''}`}
          required={isRequired}
          aria-label={t("Numéro de TVA")}
          aria-invalid={formErrors?.vat ? 'true' : 'false'}
          aria-describedby={formErrors?.vat ? 'error-vat' : undefined}
        />
        {store.vatInfo && (
          <InfoContent
            id="forVAT"
            infoField={infoField}
            showInfo={() => showInfo('forVAT')}
            hideInfo={hideInfo}
            context="vat"
            infoText={
              <p>
                {t('vat.tooltip')}
              </p>
            }
            ariaLabelShow={t("Informations sur le numéro de TVA")}
            ariaLabelHide={t("Fermer les informations")}
          />
        )}
      </div>
      {formErrors?.vat && (
        <div className="field-error" id="error-vat" role="alert">
          <span className="error-icon" aria-hidden="true">⚠️</span>
          <span className="error-message">{formErrors.vat}</span>
        </div>
      )}
    </div>
  );
};

export default VAT;